import React from 'react';

import ListenAiCard, { type ListenAiCardData } from './ListenAiCard';

const CARD_IMAGE_SIZES =
  '(min-width: 1540px) 467px, (min-width: 768px) 31vw, calc(100vw - 40px)';

/**
 * The three solutions in the order the site names them: manufacturing,
 * public safety, then the custom offer that catches everything else.
 */
const CARDS: ReadonlyArray<ListenAiCardData> = [
  {
    titleKey: 'main_card_industrial_title',
    descriptionKey: 'main_card_industrial_description',
    image: {
      desktop: {
        src: '/images/apps/home/sec_02_bg_03.webp',
        width: 1024,
        height: 614,
      },
      mobile: {
        src: '/images/apps/home/sec_02_bg_03_m.webp',
        width: 1006,
        height: 603,
      },
    },
    href: '/solution/industrial',
  },
  {
    titleKey: 'main_card_safety_title',
    descriptionKey: 'main_card_safety_description',
    image: {
      desktop: {
        src: '/images/apps/home/sec_02_bg_02.webp',
        width: 1480,
        height: 780,
      },
      mobile: {
        src: '/images/apps/home/sec_02_bg_02_m.webp',
        width: 1006,
        height: 671,
      },
    },
    href: '/solution/safety',
  },
  {
    titleKey: 'main_card_custom_title',
    descriptionKey: 'main_card_custom_description',
    image: {
      desktop: {
        src: '/images/apps/home/sec_02_bg_04.webp',
        width: 1480,
        height: 780,
      },
      mobile: {
        src: '/images/apps/home/sec_02_bg_04_m.webp',
        width: 1006,
        height: 671,
      },
    },
    href: '/solution/custom',
  },
];

/**
 * ### ListenAiCardList
 *
 * The three Listen AI solution cards as one row on larger screens and a
 * single column on smaller ones, each numbered in the corner so the row
 * reads as a set of three. Each card is a link in its entirety.
 *
 * @returns The rendered list of solution cards
 */
export default function ListenAiCardList() {
  return (
    <ul className="grid list-none grid-cols-1 gap-5 md:grid-cols-3 lg:gap-[clamp(20px,3.5vw,48px)]">
      {CARDS.map((card, index) => (
        <li key={card.href} className="min-w-0">
          <ListenAiCard
            card={card}
            ordinal={index + 1}
            count={CARDS.length}
            sizes={CARD_IMAGE_SIZES}
          />
        </li>
      ))}
    </ul>
  );
}
